import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, Divider } from "@material-ui/core";
import { useTranslation } from "react-i18next";

// Styles
import TermsOfUseStyle from "../../assets/styles/materialUI/sitePolicy/TermsOfUseStyle";

// Providers
import { useLanguage } from "../../contexts/languageContext";

function TermsOfUse({ open, onClose, onConfirm, source }) {
	const classes = TermsOfUseStyle();
	const { direction } = useLanguage();
	const { t } = useTranslation();

	return (
		<Dialog
			open={open}
			onClose={onClose}
			fullWidth
			maxWidth="md"
			classes={{ paper: classes.dialogPaper }}
			className={classes.container}
			dir={direction}
		>
			<DialogTitle disableTypography className={classes.title}>
				{t("terms.title")}
			</DialogTitle>
			<DialogContent dividers>
				<Typography variant="body2" className={classes.activationDateText}>
					{t("terms.effectiveDate")}
				</Typography>
				<Typography className={classes.paragraph}>{t("terms.intro")}</Typography>
				<Divider className={classes.privacyCometment} />
				<Typography className={classes.sectionTitle}>{t("terms.privacyCommitmentTitle")}</Typography>
				<Typography className={classes.paragraph}>{t("terms.privacyCommitmentBody")}</Typography>
				<Typography className={classes.sectionTitle}>{t("terms.informationTitle")}</Typography>
				<Typography className={classes.paragraph}>{t("terms.informationBody")}</Typography>
				<Typography className={classes.paragraph}>{t("terms.informationBody2")}</Typography>
				<Typography className={classes.paragraph}>{t("terms.informationBody3")}</Typography>
				<Typography className={classes.paragraph}>{t("terms.informationBody4")}</Typography>
				<Typography className={classes.sectionTitle}>{t("terms.accessTitle")}</Typography>
				<Typography className={classes.paragraph}>{t("terms.accessIntro")}</Typography>
				<ul className={classes.list}>
					{t("terms.accessList", { returnObjects: true }).map((item, index) => (
						<li key={index}>{item}</li>
					))}
				</ul>
				<Typography className={classes.paragraph}>{t("terms.accessBody")}</Typography>
				<Typography className={classes.sectionTitle}>{t("terms.controlTitle")}</Typography>
				<Typography className={classes.paragraph}>{t("terms.controlBody")}</Typography>
				<Typography className={classes.sectionTitle}>{t("terms.securityTitle")}</Typography>
				<Typography className={classes.paragraph}>{t("terms.securityBody")}</Typography>
				<Typography className={classes.sectionTitle}>{t("terms.ipTitle")}</Typography>
				<Typography className={classes.paragraph}>{t("terms.ipBody")}</Typography>
				<Typography className={classes.sectionTitle}>{t("terms.disclaimerTitle")}</Typography>
				<Typography className={classes.paragraph}>{t("terms.disclaimerBody")}</Typography>
				<Typography className={classes.sectionTitle}>{t("terms.updateTitle")}</Typography>
				<Typography className={classes.paragraph}>{t("terms.updateBody")}</Typography>
				<Typography className={classes.sectionTitle}>{t("terms.contactTitle")}</Typography>
				<Typography className={classes.paragraph}>{t("terms.contactBody")}</Typography>
			</DialogContent>
			<DialogActions className={classes.dialogAction}>
				<Button onClick={onConfirm} variant="contained" color="primary" className={classes.closeButton}>
					{source}
				</Button>
			</DialogActions>
		</Dialog>
	);
}

export default TermsOfUse;
